import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {NbMenuItem, NbSidebarService, NbSidebarState} from '@nebular/theme';
import {AuthService} from 'compob2b-auth';
import {BaseComponent, Customer, FileService, Settings, StoreService} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LayoutComponent extends BaseComponent implements OnInit {
  customer: Customer;
  settings: Settings;
  menuItems$: Observable<NbMenuItem[]>;
  sideBarState: NbSidebarState;
  isShowBlock = false;
  isShowMenu = true;
  menuItems: any[];
  avatarImage = '';
  loaded = false;

  constructor(
    private readonly sidebarService: NbSidebarService,
    private readonly storeService: StoreService,
    private readonly authService: AuthService,
    private readonly fileService: FileService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    super();
    this.customer = this.storeService.getCustomer();
    this.settings = this.storeService.getSettings();
  }

  ngOnInit() {
    if (this.authService.isSuperAdmin()) {
      this.document.body.classList.add('admin-role');
    }

    this.avatarImageUpdater();

    this.menuItems$ = this.storeService.getMenu().pipe(takeUntil(this.unsubscribe));
    this.menuItems$.subscribe((response) => {
      this.menuItems = response.map(item => {
        return this.buildMenuItem(item);
      });

      if (!this.menuItems.some(item => item.link === '/cabinet/security/api-tokens')) {
        this.menuItems.push({title: 'API-токены', icon: 'keypad-outline', link: '/cabinet/security/api-tokens'});
      }
      this.loaded = true;
      this.cdr.detectChanges();
    });

    this.sideBarState = this.storeService.getSidebarState();
    if (this.sideBarState === 'expanded') {
      this.isShowBlock = true;
      this.isShowMenu = false;
    }

    if (this.router.url === '/') {
      this.router.navigate(['cabinet']);
    }
  }

  private buildMenuItem(item, parent = null) {
    if (item.link == window.location.pathname.replace(/\/(edit\/\d+|item\/edit\/\d+|create|add)$/, '')) {
      item.selected = item.selected = true;
      item.expanded = true;
      if (parent) {
        parent.selected = true;
        parent.expanded = true;
      }
    }

    item.hidden = item.link == '/cabinet/dashboard';

    item.children = item.children?.map(child => {
      return this.buildMenuItem(child, item);
    });

    return item;
  }

  toggleSidebar(): boolean {
    this.storeService.toggleSidebarState();
    this.sideBarState = this.storeService.getSidebarState();
    this.isShowBlock = !this.isShowBlock;
    this.isShowMenu = !this.isShowMenu;
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  logout(): void {
    this.authService.logout();
  }

  getImageUri(): string {
    return this.fileService.getImageUri(this.customer.picture, 96);
  }

  avatarImageUpdater() {
    // if (this.customer?.picture) {
    //   this.avatarImage = this.fileService.getImageUri(this.customer.picture, 96);
    // }

    // this.avatarImageDataService.getData().pipe(takeUntil(this.unsubscribe)).subscribe(picture => {
    //   if (picture) {
    //     this.avatarImage = this.fileService.getImageUri(picture, 96);
    //   } else {
    //     this.avatarImage = '';
    //   }
    // });
  }

}
